module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('navComponent', {
    on: {
      "showlogin": _vm.upEmit
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-173911aa"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/nav/nav.vue
// module id = 615
// module chunks = 27